
import { EVENTS } from '../../constants.js';
import { lisa } from '../../Lisa.js';
import PBRMaterial from '../PBR/PBR.js';
import replacesFs from './replaces.fs?hotReplace';
import replacesVs from './replaces.vs?hotReplace';
import { DoubleSide } from 'three';
import { globalUniforms } from '../../utils/uniforms.js';

export default class Eye extends PBRMaterial {
	constructor(config, caller) {
		super(config, caller);

		this.uniforms.uTime = globalUniforms.uTime;
		this.uniforms.tNoise = { value: lisa.noise.texture };

		this.defines.USE_UV = 1

		replacesFs.use(this);
		replacesVs.use(this);


	}

}
